import { memo } from 'react';

import APIIcon from '@/assets/custom-code-icon.svg?react';
import { merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type APILogoProps = LogoProps;

const IAPILogo = ({ className, ...rest }: APILogoProps) => {
  return (
    <Logo className={merge('rounded-lg border border-gray-200 bg-white', className)} {...rest}>
      <APIIcon className="text-primary-500 size-5" />
    </Logo>
  );
};

export const APILogo = memo(IAPILogo) as typeof IAPILogo;
